import React, { useEffect, useState } from "react";
import {
  initGA,
  isAnalyticsAllowed,
  setAnalyticsConsent,
  trackPageView,
} from "../analytics";

const CookieBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (isAnalyticsAllowed() || localStorage.getItem("ga_consent") === "denied") {
      setVisible(false);
      return;
    }
    setVisible(true);
  }, []);

  const handleAccept = () => {
    setAnalyticsConsent(true);
    initGA();
    trackPageView(
      window.location.pathname + window.location.search + window.location.hash
    );
    setVisible(false);
  };

  const handleDecline = () => {
    setAnalyticsConsent(false);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-x-0 bottom-0 z-50 px-4 pb-4 text-sm text-white sm:inset-x-auto sm:right-4 sm:w-[min(520px,calc(100vw-32px))]">
      <div className="rounded-[8px] border border-white/10 bg-black/95 px-4 py-3 shadow-[0_24px_60px_-32px_rgba(0,0,0,0.95)] backdrop-blur">
        <div className="flex flex-col gap-3 sm:flex-row sm:items-center sm:justify-between">
          <div className="leading-relaxed text-gray-200">
            We use analytics cookies to understand site usage. Accept to help us
            improve.
          </div>
          <div className="flex shrink-0 gap-2">
            <button
              type="button"
              onClick={handleDecline}
              className="rounded-[6px] border border-white/25 px-3 py-1.5 text-sm text-gray-100 transition-colors hover:border-white/45"
            >
              Decline
            </button>
            <button
              type="button"
              onClick={handleAccept}
              className="rounded-[6px] bg-white px-3 py-1.5 text-sm font-medium text-black transition-colors hover:bg-gray-200"
            >
              Accept
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CookieBanner;
